import { Perf } from 'r3f-perf';
import Boat from './components/Boat';
import Island from './components/SmartcarIsland';
import Play from './components/Play';
import Socials from './components/Socials';
import Confetti from './components/Confetti';
import { Physics } from '@react-three/rapier';
import { Borders } from './components/Borders';

export default function Experience() {
  return (
    <>
      {/* <Perf position='top-left' /> */}
      {/* red=x, green=y, blue=z */}
      {/* <axesHelper args={[100]}></axesHelper> */}
      {/* <gridHelper args={[100, 100]} /> */}
      <ambientLight intensity={1.6} color='0x404040' />

      <Physics timeStep={1 / 60} gravity={[0, -11, 0]}>
        <Boat />
        <Island />
        <Play />
        <Socials />
        <Confetti />
        <Borders />
      </Physics>
    </>
  );
}
